// extracted by mini-css-extract-plugin
export var addressFields = "_ij-0";
export var animationContainer = "_ij-1";
export var footer = "_ij-2";
export var lineItems = "_ij-3";
export var modalContent = "_ij-4";
export var orderName = "_ij-5";
export var strong = "_ij-6";
export var warning = "_ij-7";